import Drawer from "../../../../drawer/Drawer";
import ManageService from "../ManageService";

const ManageServiceDrawer = ({ open, close = () => {}, getResponse = () => {}, data = {} }) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl3"}
      title={data?._id ? "Update Service" : "Add Service"}
      subtitle="View, update and modify user details and information bellow"
      drawerBodyclassName="p-0 max-h-[calc(100%-90px)]">
      <div className="h-full overflow-y-auto">
        <ManageService getResponse={getResponse} close={close} data={data} />
      </div>
    </Drawer>
  );
};

export default ManageServiceDrawer;
